"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.function.name");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _exportCostSlipUpload = require("@/api/exportCostSlipUpload/exportCostSlipUpload");
var _booking = require("@/api/bookSpace/booking");
var _utils = require("@/utils");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "bankSlipUploadDlg",
  props: {
    formDialog: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    companyName: {
      type: String,
      default: ""
    },
    pol: {
      type: String,
      default: ""
    },
    idBlNos: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      loading: null,
      acceptList: '.pdf, .jpg, .png, .bmp, .tiff',
      amountAllKRWFileList: [],
      amountAllUSDFileList: [],
      amountKRWFileList: [],
      amountUSDFileList: [],
      form: {
        paymentNo: "",
        paymentWay: "04",
        amountAllKRW: "",
        amountAllUSD: "",
        amountKRW: "",
        amountUSD: "",
        amountKRWFileId: "",
        amountUSDFileId: "",
        remark: "",
        bankSlipBlNoAndFeeId: ""
      },
      rules: {
        amountKRWFileId: [{
          required: false,
          message: this.$t('home.selectFileWaring'),
          trigger: ['change', 'blur']
        }],
        amountUSDFileId: [{
          required: false,
          message: this.$t('home.selectFileWaring'),
          trigger: ['change', 'blur']
        }]
      }
      //  home.selectFileWaring
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  methods: {
    handleChange: function handleChange(val) {
      this.form.amountKRWFileId = '';
      this.form.amountUSDFileId = '';
    },
    handleSave: function handleSave() {
      var _this = this;
      console.log(this.amountAllKRWFileList);
      this.$refs.form.validate(function (valid) {
        if (valid) {
          (0, _exportCostSlipUpload.bankSlipSaveKR)(_this.form).then(function (res) {
            if (res.success) {
              _this.$message.success(_this.$t('exportCostSlipUpload.saveSuccessfully'));
              _this.closed();
            } else {
              _this.$message.error(res.errorMessages[0]);
            }
          });
          // let formData = new FormData()
          // for (let key in this.form) {
          //   if (this.form[key] != null) {
          //     formData.append(key, this.form[key]);
          //   }
          // }
        }
      });
    },
    beforeRemove: function beforeRemove(file) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    uploadAmountAllKRWFile: function uploadAmountAllKRWFile(item) {
      var _this2 = this;
      //文件大小
      if (item.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        this.amountAllKRWFileList = [];
        return;
      }
      //文件类型
      var validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!validTypes.includes(item.file.type)) {
        this.$message.warning(this.$t('blExchangeAppointment.fileFormat'));
        this.amountAllKRWFileList = [];
        return;
      }
      //文件名称
      if (item.file.name.length > 40) {
        this.$message.warning(this.$t('blExchangeAppointment.attachmentFileLength'));
        this.amountAllKRWFileList = [];
        return;
      }
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bucket", 'commerce');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          _this2.form.amountKRWFileId = res.fileId;
          // 保留文件
          // this.amountAllKRWFileList.push({
          //   name: item.file.name,
          //   url: item.file.response
          // });
        } else {
          _this2.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this2.loading.close();
      });
    },
    handleAmountAllKRWFile: function handleAmountAllKRWFile() {
      var _this3 = this;
      this.loading = (0, _utils.load)();
      (0, _booking.deleteByFileId)(this.form.amountKRWFileId).then(function (res) {
        if (res == "success") {
          _this3.form.amountKRWFileId = "";
          _this3.$message.success(_this3.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this3.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this3.loading.close();
      });
    },
    uploadAmountAllUSDFile: function uploadAmountAllUSDFile(item) {
      var _this4 = this;
      if (item.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        this.amountAllUSDFileList = [];
        return;
      }
      var validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!validTypes.includes(item.file.type)) {
        this.$message.warning(this.$t('blExchangeAppointment.fileFormat'));
        this.amountAllUSDFileList = [];
        return;
      }
      if (item.file.name.length > 40) {
        this.$message.warning(this.$t('blExchangeAppointment.attachmentFileLength'));
        this.amountAllUSDFileList = [];
        return;
      }
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bucket", 'commerce');
      this.loading = (0, _utils.load)();
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          _this4.form.amountUSDFileId = res.fileId;
        } else {
          _this4.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this4.loading.close();
      });
    },
    handleAmountAllUSDFile: function handleAmountAllUSDFile() {
      var _this5 = this;
      this.loading = (0, _utils.load)();
      (0, _booking.deleteByFileId)(this.form.amountKRWFileId).then(function (res) {
        if (res == "success") {
          _this5.form.amountUSDFileId = "";
          _this5.$message.success(_this5.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this5.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this5.loading.close();
      });
    },
    opened: function opened() {
      var _this6 = this;
      this.$nextTick(function () {
        _this6.form.paymentNo = _this6.companyName;
        _this6.form.amountUSD = _this6.formDialog.amountUSD;
        _this6.form.amountKRW = _this6.formDialog.amountKRW;
        _this6.form.amountAllUSD = _this6.formDialog.amountAllUSD;
        _this6.form.amountAllKRW = _this6.formDialog.amountAllKRW;
        _this6.form.bankSlipBlNoAndFeeId = _this6.idBlNos;
        if (_this6.formDialog.amountAllKRW == null || _this6.formDialog.amountAllKRW == "0" || _this6.formDialog.amountAllUSD == null || _this6.formDialog.amountAllUSD == "0") {
          // this.paymentWayDisabled = true;
          _this6.$alert(_this6.$t('exportCostSlipUpload.noRate'), {
            confirmButtonText: _this6.$t('exportCostSlipUpload.confirm')
          });
        } else {
          _this6.rules.amountKRWFileId = [{
            required: true,
            message: _this6.$t('home.selectFileWaring'),
            trigger: ['change', 'blur']
          }];
          _this6.rules.amountUSDFileId = [{
            required: true,
            message: _this6.$t('home.selectFileWaring'),
            trigger: ['change', 'blur']
          }];
        }
      });
    },
    closed: function closed() {
      this.amountAllKRWFileList = [];
      this.amountAllUSDFileList = [];
      this.form.paymentWay = "04";
      this.form.amountKRWFileId = '';
      this.form.amountUSDFileId = '';
      this.$emit('handleCloseBankSlipUploadDlgKR');
    }
  }
};